export const GET_MEAL = 'GET_MEAL';
export const GET_MEAL_SUCCESS = 'GET_MEAL_SUCCESS';
export const GET_MEAL_ERROR = 'GET_MEAL_ERROR';